import React, { useState, useEffect } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { fetchActivityImage } from '../api/api';

const AuthenticatedImage = ({ url, alt, imageWidth, as: ExampleComponent = Card.Img, ...props }) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let active = true;

        const fetchImage = async () => {
            try {
                setLoading(true);
                setError(false);

                let fetchUrl = url;
                if (fetchUrl && imageWidth) {
                    const separator = fetchUrl.includes('?') ? '&' : '?';
                    fetchUrl = `${fetchUrl}${separator}width=${imageWidth}`;
                }

                const blob = await fetchActivityImage(fetchUrl);

                if (active) {
                    const imageUrl = URL.createObjectURL(blob);
                    setImageSrc(imageUrl);
                }
            } catch (err) {
                console.error("Error fetching image:", err);
                if (active) {
                    setError(true);
                }
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };

        if (url) {
            fetchImage();
        } else {
            setLoading(false);
            setError(true);
        }

        return () => {
            active = false;
            if (imageSrc) {
                URL.revokeObjectURL(imageSrc);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url, imageWidth]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px', backgroundColor: '#f8f9fa' }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (error || !imageSrc) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px', backgroundColor: '#f8f9fa', color: '#6c757d' }}>
                <small>Imagem não disponível</small>
            </div>
        );
    }

    return <ExampleComponent {...props} src={imageSrc} alt={alt} />;
};

export default AuthenticatedImage;
